import { head } from 'ramda'
import React from 'react'

import { Text } from '../../../components/presentation/Text'
import ChecklistPresenter from '../../../containers/checklists/ChecklistPresenter'
import PlacePresenter from '../../../containers/places/PlacePresenter'
import ServiceOrderPresenter from '../../../containers/serviceOrders/ServiceOrderPresenter'
import UserPresenter from '../../../containers/users/UserPresenter'

const EntityPresenter = ({ entity, entities, fontSize, ...props }) => {
  const commonProps = { fontSize, truncate: 36, ...props }

  if (!!entities && entities.length === 1) {
    entity = head(entities)
  } else if (!!entities) {
    return <EntitiesPresenter entities={entities} fontSize={fontSize} {...commonProps} />
  }

  switch (entity?.model) {
    case 'place':
      return <PlacePresenter place={entity} {...commonProps} />

    case 'serviceOrder':
      return (
        <ServiceOrderPresenter
          serviceOrder={{ ...entity, yearlyId: entity.name || 'Uma atividade' }}
          {...commonProps}
        />
      )

    case 'user':
      return <UserPresenter user={entity} {...commonProps} />

    case 'checklist':
      return <ChecklistPresenter checklist={entity} {...commonProps} />

    default:
      return (
        <Text size={fontSize} {...commonProps}>
          {entity?.name || '-'}
        </Text>
      )
  }
}

const EntitiesPresenter = ({ entities, fontSize, ...props }) => {
  if (!entities || !entities.length) return false

  let label = entities.map(entity => entity?.name || '-').join(', ')

  return (
    <Text size={fontSize} {...props}>
      {label}
    </Text>
  )
}

export default EntityPresenter
